var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1706 1.60987C15.4788 1.29877 15.8977 1.12232 16.3356 1.11909C16.7735 1.11587 17.1949 1.28613 17.5077 1.59266C17.8205 1.89919 17.9992 2.31707 18.0048 2.75497C18.0104 3.19287 17.8424 3.61519 17.5376 3.92962L8.71761 14.9557C8.56609 15.1189 8.38325 15.2498 8.18 15.3407C7.97676 15.4316 7.75728 15.4806 7.53467 15.4848C7.31206 15.489 7.09089 15.4483 6.88436 15.3652C6.67783 15.282 6.49018 15.1581 6.33261 15.0007L0.484859 9.15525C0.174108 8.84435 -0.000410617 8.42274 -0.000305128 7.98316C-0.000199639 7.54359 0.174521 7.12206 0.485421 6.81131C0.796322 6.50056 1.21793 6.32604 1.65751 6.32615C2.09708 6.32625 2.51861 6.50097 2.82936 6.81187L7.45423 11.4379L15.1267 1.66162C15.1407 1.64383 15.1557 1.62693 15.1717 1.611L15.1706 1.60987Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.ce2e6436.svg";
export { ForwardRef as ReactComponent };